import Button from 'components/Button/Button';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface SubmitButtonProps {
  label?: string;
  isDisabled?: boolean;
  ignoreDirtyCheck?: boolean;
  className?: string;
}

const SubmitButton = ({ label, isDisabled, ignoreDirtyCheck, className }: SubmitButtonProps) => {
  const {
    formState: { isSubmitting, isDirty }
  } = useFormContext();

  const { tInput } = useCustomTranslation();

  return (
    <Button
      type="primary"
      loading={isSubmitting}
      disabled={isSubmitting || (!ignoreDirtyCheck && !isDirty) || isDisabled}
      htmlType="submit"
      className={className}
    >
      {label || tInput('save_button')}
    </Button>
  );
};

export default SubmitButton;
